import {CostumResponse} from '../Dashboard/DashboardResponse'
export default class   BeneficiosDisponiblesResponse {
    constructor(
    public response?: CostumResponse  ,
    public data? : Beneficio[]  
    ){}
}

class   Beneficio {
    constructor(
    public beneficioNombre?: string,
    public codigoBeneficio?: number,
    public aplica?: string,
    public mensaje?:string,
    public monto?:number

    ){}
}

export {BeneficiosDisponiblesResponse,Beneficio}